import React, { useState } from "react";
import { FormSubmit } from "../Components/Services";
import CommonFrom from "../../../../Common/Components/Form";
function Create() {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);
  const Handler = data => {
    setstate({ ...state, loading: true });
    FormSubmit(data).then(() => {
      setstate({ ...state, loading: false });
    });
  };

  return (
    <CommonFrom
      form={input}
      loading={state.loading}
      submit={Handler}
      header="ایجاد سوال جدید"
      btnName="ثبت سوال جدید"
      textbtn="لیست سوالات"
      linkbtn="/Admin/QuestionsSetting"
      nested={["questionCategory"]}
    />
  );
}

export default Create;
export const input = [
  {
    label: "سوال ",
    size: "col-md-12 ",
    classNames: "mt-2",
    placeholder: "سوال خود را وارد کنید",
    name: "question",
    value: "",
    type: "text",
  },
  {
    label: "انتخاب دسته بندی",
    size: "col-md-3",
    classNames: "mt-2",
    placeholder: "",
    name: "category_id",
    input: "select",
    nested: "questionCategory",
  },
  {
    label: "پاسخ ",
    size: "col-md-12 ",
    classNames: "mt-2",
    placeholder: "پاسخ مورد نظر را وارد کنید",
    name: "answer",
    value: "",
    type: "text",
    input: "textarea",
  },
];
